import React, { useState } from "react";
import { Collapse, Box, Typography } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import "./summary-accordion.css";

const SummaryAccordion = ({ sections }) => {
  const [expanded, setExpanded] = useState(null);

  const toggle = (id) => {
    setExpanded(prev => (prev === id ? null : id));
  };

  return (
    <div className="summary-accordion">
      {(sections || []).map(section => {
        const isOpen = expanded === section.id;
        const items = (section.items || []).filter(Boolean);

        return (
          <div key={section.id} className="summary-accordion__item">
            <a
              id={`accordion-${section.id}`}
              className={`summary-accordion__link ${isOpen ? "active" : ""}`}
              onClick={() => toggle(section.id)}
            >
              {section.title}
              <ExpandMoreIcon
                style={{
                  color: "#0066B3",
                  transition: "transform 300ms cubic-bezier(0.4, 0, 0.2, 1)",
                  transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                }}
              />
            </a>
            <Collapse in={isOpen} timeout={300}>
              <Box py={1} px={2}>
                {items.map((item, idx) => (
                  <Box
                    key={idx}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="flex-start"
                    py={0.75}
                    style={{ gap: 12 }}
                  >
                    <Typography variant="body2" color="textSecondary">
                      {item.label}:
                    </Typography>
                    <Typography
                      variant="body1"
                      style={{
                        textAlign: "right",
                        ...(item.wordBreak && { wordBreak: "break-all" }),
                      }}
                    >
                      {item.value}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Collapse>
          </div>
        );
      })}
    </div>
  );
};

export default SummaryAccordion;
